export default __webpack_public_path__ + "static/media/tech-enablers.b74645a5.svg";